// Photo references for the climate question (Q2). Sourced from Unsplash CDN.
// Each image is a recognizable visual cue (snowy peaks, Mediterranean coast,
// continental plains, tropical beach, Nordic fjord) so users without
// meteorological background can pick by feel.
//
// Format params: `?w=640&h=480&fit=crop&q=80&auto=format` keeps mobile-safe
// payload while still readable on retina.
// Dimensions: 480×360 — 3× retina on a 160px mobile tile; reasonable weight (~25-35 KB).
// auto=format serves WebP to supporting browsers. q=75 balances quality vs speed.
export const CLIMATE_IMAGES: Record<string, string | undefined> = {
  alps:
    'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=480&h=360&fit=crop&q=75&auto=format',
  mediterranean:
    'https://images.unsplash.com/photo-1533104816931-20fa691ff6ca?w=480&h=360&fit=crop&q=75&auto=format',
  continental:
    'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=480&h=360&fit=crop&q=75&auto=format',
  tropical:
    'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=480&h=360&fit=crop&q=75&auto=format',
  northern:
    'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=480&h=360&fit=crop&q=75&auto=format',
  // "No preference" → Earth at night from orbit: climate-neutral, reads as
  // "anywhere on the map" instead of an empty placeholder tile.
  any:
    'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=480&h=360&fit=crop&q=75&auto=format',
};

// Evocative, sensation-based hints — answer "what does this climate feel like?"
// not "what are its meteorological characteristics."
export const CLIMATE_HINTS: Record<string, { en: string; ru: string }> = {
  alps: {
    en: 'Crisp air, snow on the peaks, sweater weather in July — sleeping with the window open all summer',
    ru: 'Свежий воздух, снег на вершинах, свитер в июле — всё лето спишь с открытым окном',
  },
  mediterranean: {
    en: 'Sun most of the year, dry summer heat, mild winters where frost is news — like Malaga or Nice',
    ru: 'Солнце большую часть года, сухая летняя жара, мягкая зима без морозов — как на Лазурном берегу',
  },
  continental: {
    en: 'Four distinct seasons: snowflakes in December, hot July, crisp October walks — like Munich or Vienna',
    ru: 'Четыре выраженных сезона: снег в декабре, жаркий июль, золотая осень — как в Мюнхене или Вене',
  },
  tropical: {
    en: 'Warm even in January, lush and humid, no coat ever needed — like Tenerife or the Gulf coast',
    ru: 'Тепло даже в январе, зелено и влажно, пальто не нужно — как на Тенерифе или Персидском заливе',
  },
  northern: {
    en: 'Long bright summer evenings, cold quiet winters — the kind of cold that makes cosy indoors feel earned',
    ru: 'Долгие светлые летние вечера, холодная тихая зима — уют дома, который по-настоящему заслужен',
  },
  any: {
    en: "Climate isn't my dealbreaker — show me everything",
    ru: 'Климат — не главный приоритет, покажи все варианты',
  },
};
